import React, {useEffect} from 'react';

import MaterialTable from "material-table";

import AddBox from '@material-ui/icons/AddBox';
import ArrowUpward from '@material-ui/icons/ArrowUpward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import Typography from "@material-ui/core/Typography/Typography";
import {useDispatch, useSelector} from "react-redux";
import {getLoginLogouts} from "../../../actions/i4Actions";
import {convertISODateTimeToBRLocale} from "../../../common/Util";
import {renderMilisecondsToTimeDuration} from "../../../utils/datetimehelp";


const tableIcons = {
    Add: AddBox,
    Check: Check,
    Clear: Clear,
    Delete: DeleteOutline,
    DetailPanel: ChevronRight,
    Edit: Edit,
    Export: SaveAlt,
    Filter: FilterList,
    FirstPage: FirstPage,
    LastPage: LastPage,
    NextPage: ChevronRight,
    PreviousPage: ChevronLeft,
    ResetSearch: Clear,
    Search: Search,
    SortArrow: ArrowUpward,
    ThirdStateCheck: Remove,
    ViewColumn: ViewColumn
};



const RaspaAlarmesTabela = (props) => {

    const raspaAlarmes = useSelector(state => state.raspaAlarm.raspaAlarmes);

    const dispatch = useDispatch();


    const getColumns = () => {
        return [
            {
                title: 'id',
                field: 'id',
                editable: 'never',
                hidden: true
            },


            {
                title: 'Data Hora',
                field: 'data',
                render: rowData => {return convertISODateTimeToBRLocale(rowData.data) },
                editable: 'never',
            },
            {
                title: 'Mensagem',
                field: 'mensagem',
                editable: 'never',



            },
            {
                title: 'Raspa',
                field: 'raspaId',
                editable: 'never',



            },
            {
                title: 'Usuario',
                field: 'usuario',
                editable: 'never',

            },





        ];
    }



        return (
            <React.Fragment>


                        <MaterialTable
                            icons={tableIcons}
                            title="Alarmes"
                            columns={getColumns()}
                            data={raspaAlarmes}
                            // onRowClick= {(event,  rowData) => {
                            //         props.openDialog(true,rowData);
                            // }}

                            options={{
                                filtering: true,
                                pageSize: 15,
                                pageSizeOptions: [10,25,50,100],
                                addRowPosition: 'first'
                            }}



                        />


            </React.Fragment>
        );

}

export default RaspaAlarmesTabela;

